// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024  Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import cartLineSharedStyles from "@turnerBlueprint/App/SharedStyles/CartLineSharedStyles";
import { requestRmaProductListStyles } from "@turnerBlueprint/Overrides/Widgets/RequestRma/RequestRmaProductList";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { mergeWithCss, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

requestRmaProductListStyles.productTotalPriceHeadingAndText = {
    extendedStyles: {
        ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles,
        wrapper: {},
    },
};

requestRmaProductListStyles.productDescriptionStyles = {
    ...cartLineSharedStyles.productDescription,
};

requestRmaProductListStyles.productPartNumbers = {
    ...cartLineSharedStyles.productPartNumbers,
};

requestRmaProductListStyles.returnReasonSelect = {
    mergeCss: true,
    cssOverrides: {
        formField: css`
            width: auto;
            margin-top: 10px;
        `,
        formInputWrapper: css`
            max-width: 200px;
            width: 100%;
            ${xScreen("lte", "xs")} {
                max-width: 100%;
            }
        `,
    },
};

requestRmaProductListStyles.qtyToReturnTextField = {
    cssOverrides: {
        formField: css`
            width: 125px;
            margin-right: auto;
            ${xScreen("lte", "xs")} {
                margin-right: 0;
            }
        `,
        formInputWrapper: css`
            width: 90px;
        `,
    },
};

requestRmaProductListStyles.actionsContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
        ${xScreen("lte", "md")} {
            margin-top: 12px;
        }

        [data-test-selector="qty-field"] > ${TypographyStyle} {
            font-weight: ${fontConfig.weight.medium};
        }
    `,
};

requestRmaProductListStyles.gridContainer = {
    css: css`
        margin-top: 25px;
        margin-bottom: 25px;
    `,
};

requestRmaProductListStyles.priceHeading = {
    ...cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.heading,
};

requestRmaProductListStyles.priceText = {
    ...mergeWithCss(cartLineSharedStyles.extendedUnitNetPriceText?.extendedStyles?.text, {
        css: css`
            display: inline-flex;
            width: auto;
        `,
    }),
};

requestRmaProductListStyles.unitOfMeasure = {
    ...mergeWithCss(cartLineSharedStyles.unitOfMeasure, {
        css: css`
            display: inline-flex;
            line-height: 17px;
            margin-left: 4px;
        `,
    }),
};

requestRmaProductListStyles.orderLineCardImage = {
    css: css`
        ${cartLineSharedStyles?.productImage?.linkWrappingImage?.css}
    `,
};

requestRmaProductListStyles.qtyToReturnErrorStyle = {
    mergeCss: true,
    size: 14,
    lineHeight: "22px",
    color: "danger.main",
};
